import React from "react";

const CSAEContainer: React.FC = () => {
    return (
        <div className="csae-policy-page">
            <div className="lg:px-16 px-4 lg:pt-16 pt-8 flex justify-center">
                <div className="lg:px-10 lg:py-10 px-4 py-6 max-w-[1100px]">
                    <p className="font-extrabold lg:text-[44px] text-[24px] lg:leading-[66px] leading-[40px] text-center">
                        Applaudable's Safety Standards Against Child Sexual Abuse and Exploitation (CSAE)
                    </p>

                    <div className="mt-10 lg:leading-8 leading-[25px]">
                        <p className="mb-6">
                            Applaudable is committed to protecting children and preventing any form of child sexual abuse and exploitation (CSAE) on our platform. Our policies follow Google Play's Child Safety Standards and global legal obligations.
                        </p>

                        <p className="font-bold text-xl mb-4">Zero Tolerance Policy</p>
                        <p className="mb-6">
                            We strictly prohibit:
                            <ul className="list-disc pl-6 mt-2 space-y-1">
                                <li>Child sexual abuse material (CSAM)</li>
                                <li>Grooming or predatory behavior</li>
                                <li>Sexualization of minors</li>
                                <li>Any content that exploits or harms children</li>
                            </ul>
                        </p>

                        <p className="font-bold text-xl mb-4">Detection & Moderation</p>
                        <p className="mb-6">
                            We use both AI tools and trained moderators to detect and remove harmful content.
                            <br />
                            We partner with trusted organizations to stay current on best practices.
                        </p>

                        <p className="font-bold text-xl mb-4">User Reporting</p>
                        <p className="mb-6">
                            Users can report any CSAE concerns in-app.
                            <br />
                            Reports are reviewed immediately by trained staff.
                            <br />
                            Reports can also be sent directly to: <a href="mailto:abusereport@applaudable.com" className="text-blue-600 underline">abusereport@applaudable.com</a>
                        </p>

                        <p className="font-bold text-xl mb-4">Enforcement</p>
                        <p className="mb-6">
                            Content violating our CSAE policy is removed immediately.
                            <br />
                            Offending accounts are suspended or banned.
                            <br />
                            We report incidents to relevant legal authorities and child protection organizations when required.
                        </p>

                        <p className="font-bold text-xl mb-4">Compliance</p>
                        <p className="mb-6">
                            Applaudable complies with global child safety laws.
                            <br />
                            We engage in industry-wide CSAE prevention efforts and stay aligned with the standards set by groups like NCMEC.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CSAEContainer; 